import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';
import Actions from './Actions';

export default styled(Actions)`
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};

      background: #fff;
      border-radius: 2px;
      margin: 4px;

      button {
        width: 100%;
      }
    `};

    div {
      margin-right: ${gridSizes('S')};
    }
  }

  .download-section {
    margin-top: ${gridSizes('M')};
  }

  span.buttonLabel {
    margin-right: ${gridSizes('S')};
  }

  @media print {
    display: none;
  }

  button {
    border-radius: 4px;

    display: flex;

    .btnWrapper {
      align-items: center;
    }

    svg {
      margin: 0 0.6rem 0 0;
      width: 12px;
      height: 12px;
    }
  }

  .repeat-btn {
    button {
      border: none;

      background-color: var(--primary500);
      color: var(--white);

      svg {
        fill: var(--white);
      }

      &:hover {
        background-color: var(--primary900);
      }
    }
  }

  .edit-btn {
    button {
      border: none;

      background-color: var(--primary100);
      color: var(--primary900);

      svg {
        fill: var(--primary900);
      }

      &:hover {
        background-color: var(--primary200);
      }
    }
  }

  .cancel-btn {
    button {
      border: none;

      background-color: var(--error100);
      color: var(--error900);

      svg {
        fill: var(--error900);
      }

      &:hover {
        background-color: var(--error300);
      }
    }
  }
`;
